import { render, staticRenderFns } from "./CameraPhoto.vue?vue&type=template&id=9ad00292"
import script from "./CameraPhoto.vue?vue&type=script&lang=js"
export * from "./CameraPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports